import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import {
  AsyncTypeahedSelect,
  errorMessage,
  RadioGroup,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Row, Col, Container, Card, CardBody, CardHeader } from "reactstrap"
import {
  change,
  Field,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import {
  addCommunication,
  getEventsBySearch,
  getMetaTags,
  getUsers,
  getUsersBySearch,
  resetUsersList,
  updateCommunication,
} from "store/actions"
import validate from "./notificationFormValidation"
import {
  getCurrentDate,
  getCurrentTimeZone,
  getTimeZones,
  mapApiToNotification,
  mapNotificationFormToApi,
} from "../utils"
import PushNotificationPreview from "./pushNotificationPreview"
import InAppMessagePreview from "./inAppMessagePreview"

const NotificationForm = ({
  notificationType,
  audience,
  getMetaTags,
  metaTags,
  events,
  getEventsBySearch,
  usersBySearch,
  getUsersBySearch,
  change,
  handleSubmit,
  addCommunication,
  vendorId,
  history,
  communication,
  initializeForm,
  updateCommunication,
  individualUsers,
  getUsers,
  resetUsersList,
}) => {
  useEffect(() => {
    getMetaTags({})
    if (communication) {
      initializeForm(mapApiToNotification(communication))
    }
    if (JSON.parse(localStorage.getItem("commUsers"))) {
      getUsers({
        user_ids: JSON.parse(localStorage.getItem("commUsers")),
      })
    }
    return () => {
      if (JSON.parse(localStorage.getItem("commUsers"))) {
        localStorage.removeItem("commUsers")
        resetUsersList()
      }
    }
  }, [])

  useEffect(() => {
    if (individualUsers) {
      change("audience", "Individual users")
      change(
        "userSearch",
        Object.values(individualUsers).map(({ last_name, first_name, id }) => ({
          label: `${first_name} ${last_name}`,
          value: id,
        }))
      )
    }
  }, [individualUsers])

  const handleSendNow = data => {
    if (communication) {
      updateCommunication(
        {
          ...communication,
          ...mapNotificationFormToApi(data),
          send: true,
          notification_date: null,
          notification_timezone: null,
        },
        history
      )
    } else {
      addCommunication(
        {
          ...mapNotificationFormToApi(data),
          send: true,
          vendor_id: vendorId,
        },
        history
      )
    }
  }

  const handleSendLater = data => {
    let dateDetails = null
    if (data?.date) {
      const date = new Date(`${data?.date} ${data?.time}:00 ${data?.timeType} `)
      dateDetails = {
        notification_date: `${data?.date} ${
          date?.getHours() < 10 ? `0${date?.getHours()}` : date?.getHours()
        }:00:00`,
        notification_timezone: data?.timeZone,
      }
    }
    if (communication) {
      updateCommunication(
        {
          ...communication,
          ...mapNotificationFormToApi(data),
          send: false,
          ...(dateDetails ? dateDetails : {}),
        },
        history
      )
    } else {
      addCommunication(
        {
          ...mapNotificationFormToApi(data),
          send: false,
          vendor_id: vendorId,
          ...(dateDetails ? dateDetails : {}),
        },
        history
      )
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags
          title={communication ? "Edit Notification" : "Add Notification"}
        />
        <Container fluid>
          <BreadcrumbTitle
            title={
              communication
                ? `Edit Notification: ${communication?.title}`
                : "Add Notification"
            }
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Communications",
                link: "/communications",
              },
              {
                title: communication ? "Edit Notification" : "Add Notification",
              },
            ]}
          />
          <Card>
            <CardBody>
              <Row className={"justify-content-end"}>
                <Col sm={4} lg={3} xl={2} className="my-1">
                  <SaveButton
                    type="button"
                    fullWidth={true}
                    color="light"
                    content="Cancel"
                    onClick={() => history.goBack()}
                  />
                </Col>
                <Col sm={4} lg={3} xl={2} className="my-1">
                  <SaveButton
                    type="button"
                    fullWidth={true}
                    content={"SAVE & SEND LATER"}
                    onClick={handleSubmit(handleSendLater)}
                  />
                </Col>
                <Col sm={4} lg={3} xl={2} className="my-1">
                  <SaveButton
                    type="button"
                    fullWidth={true}
                    content={"SAVE & SEND NOW"}
                    onClick={handleSubmit(handleSendNow)}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xl={8}>
                  <form>
                    <Card>
                      <CardHeader>
                        <h3>{"NOTIFICATION TITLE & TYPE"}</h3>
                      </CardHeader>
                      <CardBody>
                        <Row className="mb-3">
                          <Col xs={12} md={4} sm={6} lg={4} className={"mb-2"}>
                            Communication Title:
                          </Col>
                          <Col xs={12} md={8} sm={6} lg={8}>
                            <Field
                              name="communicationTitle"
                              component={TextField}
                            />
                          </Col>
                        </Row>
                        <Row className="my-3">
                          <Col xs={12} md={4} sm={6} lg={4} className={"mb-2"}>
                            Notification Type:
                          </Col>
                          <Col xs={12} sm={6} md={8}>
                            <Row>
                              <Col md={6}>
                                <Field
                                  name="notificationType"
                                  type="radio"
                                  component={RadioGroup}
                                  label="Push Notification"
                                  value="1"
                                />
                              </Col>
                              <Col md={6}>
                                <Field
                                  name="notificationType"
                                  type="radio"
                                  component={RadioGroup}
                                  label="In-App Message"
                                  value="2"
                                />
                              </Col>
                              <Col xs={12}>
                                <Field
                                  name="notificationType"
                                  component={errorMessage}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardHeader>
                        <h3>CREATE MESSAGE</h3>
                      </CardHeader>
                      <CardBody>
                        <Row className="mb-3">
                          <Col xs={12} sm={6} md={4} className={"mb-2"}>
                            Subject:
                          </Col>
                          <Col xs={12} sm={6} md={8}>
                            <Field
                              name="subject"
                              component={TextField}
                              maxLength="40"
                            />
                          </Col>
                        </Row>
                        <Row className="my-3">
                          <Col xs={12} sm={6} md={4} className={"mb-2"}>
                            Message:
                          </Col>
                          <Col xs={12} sm={6} md={8}>
                            <Field
                              name="message"
                              component={TextField}
                              maxLength={
                                notificationType === "1" ? "50" : "120"
                              }
                            />
                          </Col>
                        </Row>
                        {notificationType === "1" && (
                          <Row className="my-3">
                            <Col xs={12} sm={6} md={4} className={"mb-2"}>
                              Web Link (optional):
                            </Col>
                            <Col xs={12} sm={6} md={8}>
                              <Field
                                name={"webLink"}
                                component={TextField}
                                placeholder={
                                  "Cut & paste the URL here (Include http:// or https://)"
                                }
                              />
                            </Col>
                          </Row>
                        )}
                      </CardBody>
                    </Card>
                    <Card>
                      <CardHeader>
                        <h3>AUDIENCE</h3>
                      </CardHeader>
                      <CardBody>
                        <Row className="form-group mb-3">
                          <Col xs="auto" className="my-1">
                            <Field
                              name="audience"
                              component={RadioGroup}
                              label="All Users"
                              type="radio"
                              value="All Users"
                            />
                          </Col>
                          <Col xs="auto" className="my-1">
                            <Field
                              name="audience"
                              component={RadioGroup}
                              label="All Logged Users"
                              type="radio"
                              value="All Logged Users"
                            />
                          </Col>
                          <Col xs="auto" className="my-1">
                            <Field
                              name="audience"
                              component={RadioGroup}
                              label="Users in specific experiences"
                              type="radio"
                              value="Users in specific experiences"
                            />
                          </Col>
                          <Col xs="auto" className="my-1">
                            <Field
                              name="audience"
                              component={RadioGroup}
                              label="Individual users"
                              type="radio"
                              value="Individual users"
                            />
                          </Col>
                          <Col xs="auto" className="my-1">
                            <Field
                              name="audience"
                              component={RadioGroup}
                              label="By tags"
                              type="radio"
                              value="By tags"
                            />
                          </Col>
                          <Col xs="auto" className="my-1">
                            <Field
                              name="audience"
                              component={RadioGroup}
                              label="Non-logged in users"
                              type="radio"
                              value="Non-logged in users"
                            />
                          </Col>
                          <Col xs={12}>
                            <Field component={errorMessage} name="audience" />
                          </Col>
                        </Row>
                        {audience === "Users in specific experiences" && (
                          <Row className="my-3">
                            <Field
                              name="experienceSearch"
                              component={AsyncTypeahedSelect}
                              placeholder="Search for specific experiences"
                              options={events.map(event => ({
                                label: `${event.name}`,
                                value: event.id,
                              }))}
                              inlineValue={false}
                              onInputChange={text =>
                                getEventsBySearch({ t: text })
                              }
                              isMulti={true}
                            />
                          </Row>
                        )}
                        {audience === "Individual users" && (
                          <Row className="my-3">
                            <Field
                              name="userSearch"
                              component={AsyncTypeahedSelect}
                              placeholder="Search for specific users"
                              options={usersBySearch.map(user => ({
                                label: `${user.first_name} ${user.last_name} (${user.email})`,
                                value: user.id,
                              }))}
                              inlineValue={false}
                              onInputChange={text =>
                                getUsersBySearch({ t: text })
                              }
                              isMulti={true}
                            />
                          </Row>
                        )}
                        {audience === "By tags" && (
                          <Row className="my-3">
                            <Field
                              name="tagSearch"
                              placeholder="Enter tag"
                              component={AsyncTypeahedSelect}
                              options={metaTags.map(tag => ({
                                label: tag.tag,
                                value: tag.id,
                              }))}
                              isMulti={true}
                            />
                          </Row>
                        )}
                      </CardBody>
                    </Card>
                    <Card>
                      <CardHeader>
                        <h3>SCHEDULED SEND (OPTIONAL)</h3>
                      </CardHeader>
                      <CardBody>
                        <Row className="mb-3">
                          <Col xs={12} sm={6} md={4} className={"mb-2"}>
                            {"Send Date & Time:"}
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} sm={5} md={3} className={"mb-2"}>
                            <Field
                              name={"date"}
                              component={TextField}
                              type="date"
                              min={getCurrentDate()}
                            />
                          </Col>
                          <Col xs={12} sm={2} className={"mb-2"}>
                            <Field
                              name={"time"}
                              component={TextField}
                              type="number"
                              min="1"
                              max="12"
                              placeholder="HH"
                            />
                          </Col>
                          <Col xs={12} sm={3} md={2} className=" mb-2">
                            <Field
                              name={"timeType"}
                              component={SingleSelectField}
                              placeholder="AM/PM"
                              options={[
                                { label: "AM", value: "AM" },
                                { label: "PM", value: "PM" },
                              ]}
                              isSearchable={false}
                              defaultValue={{ label: "AM", value: "AM" }}
                            />
                          </Col>
                          <Col xs={12} sm={5} md={4} className=" mb-2">
                            <Field
                              name={"timeZone"}
                              component={SingleSelectField}
                              placeholder="Select timezone"
                              options={getTimeZones()}
                              isSearchable={false}
                            />
                          </Col>
                          <Col>
                            <i
                              className="bx bx-sm bx-x"
                              style={{
                                cursor: "pointer",
                                paddingTop: "7px",
                                color: "#34c38f",
                              }}
                              onClick={() => {
                                change("date", null)
                                change("time", null)
                                change("timeType", "AM")
                                change("timeZone", getCurrentTimeZone())
                              }}
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </form>
                </Col>
                <Col xl={4} className="mt-4 d-none d-xl-block position-sticky ">
                  {notificationType === "1" ? (
                    <div style={{ position: "sticky" }}>
                      <h5 style={{ textAlign: "center" }}>
                        Push Notification Preview
                      </h5>
                      <PushNotificationPreview />
                    </div>
                  ) : (
                    <div style={{ position: "sticky" }}>
                      <h5 style={{ textAlign: "center" }}>
                        In-App Message Preview
                      </h5>
                      <InAppMessagePreview />
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col xl={8}>
                  <Row className={"justify-content-center mb-3"}>
                    <Col xs={6} sm={4} md={3}>
                      <SaveButton
                        type="button"
                        fullWidth={true}
                        onClick={handleSubmit(handleSendLater)}
                        content={"SAVE & SEND LATER"}
                      />
                    </Col>
                    <Col xs={6} sm={4} md={3}>
                      <SaveButton
                        type="button"
                        fullWidth={true}
                        onClick={handleSubmit(handleSendNow)}
                        content={"SAVE & SEND NOW"}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.NOTIFICATION)

const mapStateToProps = state => ({
  notificationType: selector(state, "notificationType"),
  audience: selector(state, "audience"),
  metaTags: state.Tags.metaTags,
  events: state.Communications.events,
  usersBySearch: state.SiteUsers.usersBySearch,
  vendorId: state.Login.vendorId,
  individualUsers: state.Communications.individualUsers,
})

const mapDispatchToProps = dispatch => ({
  getMetaTags: values => dispatch(getMetaTags(values)),
  getEventsBySearch: values => dispatch(getEventsBySearch(values)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.NOTIFICATION, `${field}`, value)),
  addCommunication: (values, history) =>
    dispatch(addCommunication(values, history)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.NOTIFICATION, values)),
  updateCommunication: (values, history) =>
    dispatch(updateCommunication(values, history)),
  getUsers: values => dispatch(getUsers(values)),
  resetUsersList: () => dispatch(resetUsersList()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAMES.NOTIFICATION,
    validate,
    initialValues: {
      notificationType: "1",
      audience: "All Users",
      timeType: "AM",
      timeZone: getCurrentTimeZone(),
    },
  })(withRouter(NotificationForm))
)
